import { useState } from 'react'
import { saveSettings } from '../lib/supabase'

export default function ProfileCompletePrompt({ userId, onComplete, onSkip }) {
  const [practiceName, setPracticeName] = useState('')
  const [fullName, setFullName]         = useState('')
  const [saving, setSaving]             = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    await saveSettings(userId, {
      practice_name:     practiceName.trim(),
      full_name:         fullName.trim(),
      profile_completed: true,
    })
    setSaving(false)
    onComplete()
  }

  const handleSkip = async () => {
    await saveSettings(userId, { profile_completed: true })
    onSkip()
  }

  return (
    <div className="modal-backdrop">
      <div className="modal fade-up" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div className="modal-header" style={{ border: 'none', paddingBottom: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, background: 'var(--accent-light)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>👋</div>
            <div>
              <h3 style={{ margin: 0 }}>Welcome to Receipt Chaser</h3>
              <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--ink-muted)' }}>Tell your clients who you are</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ paddingTop: 20 }}>
            <p style={{ fontSize: '0.88rem', color: 'var(--ink-muted)', marginBottom: 20, lineHeight: 1.6 }}>
              This information appears in emails to your clients. You can update it any time in Settings.
            </p>
            <div className="form-group">
              <label htmlFor="practiceName">Practice name</label>
              <input
                id="practiceName"
                className="input"
                value={practiceName}
                onChange={e => setPracticeName(e.target.value)}
                placeholder="e.g. John Smith Bookkeeping"
                required
                autoFocus
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label htmlFor="fullName">Your full name</label>
              <input
                id="fullName"
                className="input"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                placeholder="e.g. Sarah Collins"
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-ghost btn-sm" onClick={handleSkip} style={{ color: 'var(--ink-faint)' }}>
              Skip for now
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save and continue →'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
